import userIcon from '../../assets/user.svg';
import React from 'react';

const UserCardIcon = () => <img src={userIcon} alt="user-card-icon" />;

export default UserCardIcon;
